<div class="card">
  <div *ngIf="!hideActions" class="card-header d-md-block d-none">
    <app-page-title [breadcrumbItems]="breadCrumbItems"/>
  </div>
  <div class="row">
    <div class="col-xl-12">
        <div class="p-3">
          <div class="d-flex justify-content-between align-items-center">
            <h4 class="fw-bold text-dark m-0 d-flex align-items-center">
              <i class="las la-money-check-alt me-2"></i> {{ 'PAYMENT.MY_INCOME_EXPENSES'|translate }}
            </h4>
            <button (click)="onAdd()" class="btn btn-primary d-inline-flex align-items-center gap-1 fs-18">
              <i class="las la-plus fs-20"></i><span class="fw-bolder">{{ 'PAYMENT.ADD_INTAKE'|translate }}</span>
            </button>
          </div>
        </div>

        <div class="">
          <!-- Nav tabs -->
          <ul class="nav nav-tabs nav-tabs-custom nav-success my-3" role="tablist">
            <li (click)="assignToCurrantFilter(allFilter.All)" class="nav-item">
              <a [ngClass]="{'active': paymentFilter === allFilter.All}" class="nav-link active cursor-pointer">
                {{ "ALL" | translate }}
              </a>
            </li>

            @for (item of [PaymentStatus.PAID, PaymentStatus.PENDING, PaymentStatus.UNPAID, PaymentStatus.CANCELED]; track item) {
              <li class="nav-item" (click)="assignToCurrantFilter(item)">
                <a class="nav-link cursor-pointer" [ngClass]="{'active': paymentFilter === item}">
                  {{ "PAYMENT.STATUSES." + item | translate }}
                </a>
              </li>
            }
          </ul>
          <div class="card-body">
            <p-table
              [hasList]="service.hasList"
              (delete)="onDelete($event)"
              (edit)="onEdit($event)"
              (onLazyLoad)="loadData($event)"
              (onPage)="pageChange($event)"
              (view)="onView($event)"
              [columns]="service.tableColumns"
              [dataKey]="'id'"
              [first]="first"
              [globalSearch]="globalSearch"
              [hasActions]="service.hasActions"
              [hasAdd]="false"
              [hasDelete]="false"
              [hasEdit]="false"
              [hasView]="false"
              [loading]="loading()"
              [rows]="rows"
              [scrollHeight]="'calc(111vh - 470px)'"
              [selectionMode]="'single'"
              [title]="service.title"
              [totalRecords]="total"
              [value]="list"
              paginatorPosition="bottom"
              tableStyleClass="table table-hover custom-table"
            >
              <ng-template #cells let-data>
                @for (col of service.tableColumns; track col) {
                  <td>
                  <span class="p-datatable-column-title">
                    @if (col.iconClass) {
                      <i [class]="col.iconClass"></i>
                    }
                    {{ (col.label ?? col.fieldName) | translate }}
                  </span>

                    @switch (col.fieldName) {
                      @case ('paymentAmount') {
                        {{ data.paymentAmount | moneyFormat }}
                      }
                      @case ('actions') {
                        <div class="d-flex align-items-center gap-2">
                          <a
                            (click)="onView(data)"
                            ngbTooltip="{{'INVOICES.DETAILS'|translate}}"
                            class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                            <i class="las la-info-circle fs-20"></i>
                          </a>
                          <a
                            (click)="onEdit(data)"
                            ngbTooltip="{{ 'EDIT' | translate }}"
                            class="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center action-button">
                            <i class="las la-pen-fancy fs-20"></i>
                          </a>
                          <a
                            (click)="onDelete(data)"
                            ngbTooltip="{{ 'DELETE' | translate }}"
                            class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center action-button">
                            <i class="las la-trash fs-20"></i>
                          </a>
                        </div>
                      }
                      @case ('status') {
                        <span paymentStatusBadge [type]="data.status"></span>
                      }
                      @default {
                        <p-table-cell-value [data]="data" [column]="col"></p-table-cell-value>
                      }
                    }
                  </td>
                }
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>

